"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryWarningLabels = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const text_area_1 = require("client/components/material/text-area");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const warning_store_1 = require("client/modules/inventory/modules/inventory-warning-labels/warning-store");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./inventory-manual-create.less");
let InventoryWarningLabels = class InventoryWarningLabels extends react_1.Component {
    constructor() {
        super(...arguments);
        this.id = location.pathname.split("/").pop();
        this.addToAllSitesSites = false;
        this.name = warning_store_1.inventoryWarningStore.name || "";
        this.inventoryWarningLabels = {
            labelOne: warning_store_1.inventoryWarningStore.warningLabelOne || "",
            labelTwo: warning_store_1.inventoryWarningStore.warningLabelTwo || "",
            labelThree: warning_store_1.inventoryWarningStore.warningLabelThree || "",
            labelFour: warning_store_1.inventoryWarningStore.warningLabelFour || "",
            labelFive: warning_store_1.inventoryWarningStore.warningLabelFive || "",
            labelSix: warning_store_1.inventoryWarningStore.warningLabelSix || "",
            inventoryId: warning_store_1.inventoryWarningStore.id || ""
        };
        this.handleCancel = () => {
            const [siteId] = this.props.params;
            router_1.RouteManager.transitionTo(`/formulary/${siteId}/${this.id}`);
        };
        this.handleSubmit = async () => {
            const saveResult = await warning_store_1.inventoryWarningStore.saveWarningLabels();
            // const { success, code, errProp } = saveResult;
            // if (success) {
            //   this.error = "";
            //   inventoryWarningStore.getWarningLabels(this.id);
            // } else {
            //   this.error = code;
            //   this.missing[errProp] = true;
            // }
        };
        this.handleChangeString = (fieldName) => (event, value) => {
            warning_store_1.inventoryWarningStore[fieldName] = value;
        };
    }
    componentWillMount() {
        this.error = "";
        warning_store_1.inventoryWarningStore.getWarningLabels(this.id);
    }
    componentDidMount() {
        const [siteId, inventoryId] = this.props.params;
        warning_store_1.inventoryWarningStore.getWarningLabels(inventoryId);
    }
    render() {
        const medicationTitleStyle = {
            marginBottom: "0",
            paddingLeft: "40px"
        };
        const canEdit = store_1.usersStore.permissions.UpdateFormulary;
        return (React.createElement("div", { className: "inventory" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "inventory__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Warning Labels" }))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "edit-inventory" },
                    React.createElement(ui_1.UiForm, { buttons: canEdit && [
                            React.createElement(ui_1.UiButton, { onClick: this.handleCancel }, "Cancel"),
                            "Save"
                        ], loading: warning_store_1.inventoryWarningStore.loading, onSubmit: this.handleSubmit, error: this.error },
                        React.createElement("h3", { style: medicationTitleStyle },
                            " ",
                            warning_store_1.inventoryWarningStore.name || "Medication Name:",
                            " "),
                        React.createElement("div", { className: "main" },
                            React.createElement("div", { className: "identification-info" },
                                React.createElement("h3", { style: { textAlign: "left", width: "160px" } }, "Label 1:"),
                                React.createElement("div", { className: "notes-section" }, canEdit ? (React.createElement(text_area_1.MaterialTextArea, { className: "notes", onChange: this.handleChangeString("warningLabelOne"), placeholder: "Label Example: For External Use Only", value: warning_store_1.inventoryWarningStore.warningLabelOne })) : (React.createElement("span", null, warning_store_1.inventoryWarningStore.warningLabelOne))),
                                React.createElement("h3", { style: { textAlign: "left", marginTop: "20px" } }, "Label 2:"),
                                React.createElement("div", { className: "notes-section" }, canEdit ? (React.createElement(text_area_1.MaterialTextArea, { className: "notes", onChange: this.handleChangeString("warningLabelTwo"), placeholder: "Label Example: For External Use Only", value: warning_store_1.inventoryWarningStore.warningLabelTwo })) : (React.createElement("span", null, warning_store_1.inventoryWarningStore.warningLabelTwo))),
                                React.createElement("h3", { style: { textAlign: "left", marginTop: "20px" } }, "Label 3:"),
                                React.createElement("div", { className: "notes-section" }, canEdit ? (React.createElement(text_area_1.MaterialTextArea, { className: "notes", onChange: this.handleChangeString("warningLabelThree"), placeholder: "Label Example: For External Use Only", value: warning_store_1.inventoryWarningStore.warningLabelThree })) : (React.createElement("span", null, warning_store_1.inventoryWarningStore.warningLabelThree))),
                                React.createElement("h3", { style: { textAlign: "left", marginTop: "20px" } }, "Label 4:"),
                                React.createElement("div", { className: "notes-section" }, canEdit ? (React.createElement(text_area_1.MaterialTextArea, { className: "notes", onChange: this.handleChangeString("warningLabelFour"), placeholder: "Label Example: For External Use Only", value: warning_store_1.inventoryWarningStore.warningLabelFour })) : (React.createElement("span", null, warning_store_1.inventoryWarningStore.warningLabelFour))),
                                React.createElement("h3", { style: { textAlign: "left", marginTop: "20px" } }, "Label 5:"),
                                React.createElement("div", { className: "notes-section" }, canEdit ? (React.createElement(text_area_1.MaterialTextArea, { className: "notes", onChange: this.handleChangeString("warningLabelFive"), placeholder: "Label Example: For External Use Only", value: warning_store_1.inventoryWarningStore.warningLabelFive })) : (React.createElement("span", null, warning_store_1.inventoryWarningStore.warningLabelFive))),
                                React.createElement("h3", { style: { textAlign: "left", marginTop: "20px" } }, "Label 6:"),
                                React.createElement("div", { className: "notes-section" }, canEdit ? (React.createElement(text_area_1.MaterialTextArea, { className: "notes", onChange: this.handleChangeString("warningLabelSix"), placeholder: "Label Example: For External Use Only", value: warning_store_1.inventoryWarningStore.warningLabelSix })) : (React.createElement("span", null, warning_store_1.inventoryWarningStore.warningLabelSix))))))))));
    }
};
__decorate([
    mobx_1.observable
], InventoryWarningLabels.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningLabels.prototype, "addToAllSitesSites", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningLabels.prototype, "name", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningLabels.prototype, "error", void 0);
__decorate([
    mobx_1.observable
], InventoryWarningLabels.prototype, "inventoryWarningLabels", void 0);
InventoryWarningLabels = __decorate([
    mobx_react_1.observer
], InventoryWarningLabels);
exports.InventoryWarningLabels = InventoryWarningLabels;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-warning-labels/inventory-warning-labels.tsx
// module id = 3505
// module chunks = 0